import template from './ko-field-view.html';

/**
 * Render fields knockout component class
 * @kind component
 * @class SampleComponent
 * @description Sample Component that shows the name value
 */
class ViewFieldViewModel
{
	constructor(input)
	{
		this.input = ko_helper.safe_observable(input);
		this.value = ko_helper.safe_observable(ko.unwrap(input.value));

		// Normalize JSON-like string values (arrays/objects) so downstream components
		// and multiple-value detection work consistently across views (e.g., table vs card).
		try
		{
			let raw = input?.value;
			if (typeof raw === 'string')
			{
				raw = raw.trim();
				if (raw.startsWith('[') || raw.startsWith('{'))
				{
					const parsed = JSON.parse(raw);
					this.value(parsed);
				}
			}
		}
		catch (err)
		{
			// If parsing fails, leave the original string value as-is
		}
		this.multiple = ko_helper.safe_observable(false);
		this.help_text = ko_helper.safe_observable(null);
		this.label = ko_helper.safe_observable(null);
		this.field = ko_helper.safe_observable();
		this.hidden = ko_helper.safe_observable(false);

		this.component_name = null;
		this.params = {};

		if (input.field.options && input.field.options.hidden)
			this.hidden(input.field.options.hidden);

		this.render_field();
	}

	render_field()
	{
		let field = ko.unwrap(this.input().field) || {};
		if (!field.type && field.options)
			field = Object.assign({}, field, field.options);

		if (!field.name && field.field_name)
			field.name = field.field_name;

		if (!field.type)
		{
			console.warn(`No type specified for field ${field.name || field.field_name}, defaulting to text`);
			field.type = 'text';
		}

		this.component_name = this.get_component_for_field_type(field.type);

		if (!this.component_name)
		{
			console.warn(new Error(`No component for field ${field.name} with type=${field.type}`));
			this.component_name = this.get_component_for_field_type('text');
		}

		if (field.help_text)
			this.help_text(field.help_text);

		if (field.multiple)
			this.multiple(field.multiple);

		if (!field.label && field.name)
		{
			let label = field.name;
			label = label.replace(/_/g, ' ');
			label = label.replace(/\b\w/g, char => char.toUpperCase());
			this.label(label);
		}

		field.value = this.value();
		this.params = field;
	}

	// Computed to check if we should render multiple values
	isMultipleValue = ko.pureComputed(() => {
		const val = this.value();
		return Array.isArray(val) && val.length > 0;
	});

	// Computed to get the array of values
	valuesArray = ko.pureComputed(() => {
		const val = this.value();
		if (Array.isArray(val)) return val;
		return [];
	});

	get_component_for_field_type(name)
	{
		let field_type = Grape.registry.getItem('RenderFieldsFieldTypes', name);

		if (!field_type)
		{
			console.error(new Error(`Unknown render field type "${name}". Falling back to "text"`));
			field_type = Grape.registry.getItem('RenderFieldsFieldTypes', 'text');
		}

		if (!field_type)
			return;
		if (field_type.vcomponent)
			return field_type.vcomponent;

		return field_type.component;
	}
}

export default
{
	name: 'ko-field-view',
	viewModel: ViewFieldViewModel,
	module_type: 'ko',
	template: template
};
